import {
  generateBorder,
  generatePadding,
  mediaQuery,
  Typography
} from '@lacedltd/laced-components'
import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const SelectContainer = styled.div({
  marginBottom: tokens.spacing[6],

  label: {
    marginBottom: tokens.spacing[3]
  }
})

export const DropdownIndicator = styled.div<{ menuIsOpen: boolean }>(
  ({ menuIsOpen }) => ({
    transition: 'all 0.2s ease-in',
    transform: `rotate(${menuIsOpen ? 0 : '180deg'})`
  })
)

export const SelectOption = styled.div<{ image: boolean }>(({ image }) => ({
  display: 'flex',
  gap: image ? tokens.spacing[3] : 0,

  span: {
    marginLeft: image ? 0 : tokens.spacing[3],
    color: tokens.color.airJordan[600]
  }
}))

export const SiteSettingsModal = styled.div({
  width: '25rem',
  display: 'flex',
  flexDirection: 'column',

  h4: {
    marginBottom: tokens.spacing[5]
  },

  span: {
    margin: 0
  },

  button: {
    width: '100%'
  },

  [mediaQuery.m.max]: {
    width: '100%'
  }
})

export const ModalHeading = styled(Typography.Heading)({
  marginBottom: tokens.spacing[5]
})

export const Trigger = styled.button({
  all: 'unset',
  cursor: 'pointer',
  display: 'none',
  gap: tokens.spacing[3],
  fontSize: tokens.fontSize[1],
  color: tokens.color.airJordan[600],
  alignItems: 'center',
  lineHeight: '0.8125rem', // This is 13px to ensure alignment is central

  [mediaQuery.m.min]: {
    display: 'flex'
  }
})

export const SiteSettingsForm = styled.div({
  marginTop: tokens.spacing[5],

  form: {
    margin: 0
  },

  label: {
    display: 'flex',
    color: tokens.color.airJordan[600],
    marginBottom: tokens.spacing[2]
  },

  // Need to use div select to override default styles coming from createForm elements
  'div select': {
    fontSize: tokens.fontSize[3],
    height: '3.125rem',
    padding: generatePadding(0, 'spacing.5'),
    border: generateBorder('xs', 'solid', 'airJordan.200'),
    marginBottom: tokens.spacing[5]
  },

  // Inline Error Styling
  p: {
    marginTop: `-${tokens.spacing[4]}`,
    marginBottom: tokens.spacing[5]
  },

  button: {
    width: '100%',
    marginTop: tokens.spacing[3]
  }
})
